import { useAppI18N } from '@/app'
import { Button, Modal, Text, View } from '@/components'
import { useSearchedIndustry } from '@/utils'
import { AnyFunction } from '@codeleap/common'
import { ModalProps } from '@codeleap/web'

type FindOrganisationsExplainerModalProps = Partial<ModalProps> & {
  visible: boolean
  toggle: AnyFunction
}

export const FindOrganisationsExplainerModal = (props: FindOrganisationsExplainerModalProps) => {
  const { toggle, visible, ...modalProps } = props
  const { t } = useAppI18N()

  const { text } = useOrganisattionsExplainerModal()

  return (
    <Modal
      visible={visible}
      showClose={false}
      toggle={toggle}
      debugName={'Find Organisations Explainer Modal'}
      {...modalProps}
      variants={['centered']}
    >
      <View variants={['gap:2', 'column']}>
        <Text variants={['h4', 'color:neutral9', 'textCenter']} text={text.title} />
        <Text
          variants={['center', 'textCenter']}
          text={text.description}
        />
        <Button text={t('modals.orgInfo.confirmButton')} onPress={toggle} debugName={'Dismiss Modal'} />
      </View>
    </Modal>
  )
}

export const useOrganisattionsExplainerModal = () => {
  const { t } = useAppI18N()

  const searchedIndustry = useSearchedIndustry()

  const hasIndustry = !!searchedIndustry?.industry

  const variant = hasIndustry ? 'industry' : 'default'

  const text = {
    'default': {
      title: t(`organisations.findTitle`),
      description: t(`organisations.findSubtitle`),
    },
    'industry': {
      title: t(`organisations.industryExplainerTitle`),
      description: t(`organisations.findSubtitle`),
    },
  }[variant]

  return { text, searchedIndustry, hasIndustry }
}
